class HeroSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-hero-track]');
    this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
    this.index = 0;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.querySelector('[data-hero-prev]')?.addEventListener('click', () => this.go(this.index - 1));
    this.querySelector('[data-hero-next]')?.addEventListener('click', () => this.go(this.index + 1));
    this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.index))));

    let startX = 0;
    this.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
    this.addEventListener(
      'touchend',
      (e) => {
        const delta = e.changedTouches[0].clientX - startX;
        if (Math.abs(delta) > 40) this.go(delta < 0 ? this.index + 1 : this.index - 1);
      },
      { passive: true }
    );

    if (this.dataset.autoplay === 'true' && !this.reducedMotion && this.slides.length > 1) {
      this.startAutoplay();
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
    }
  }

  go(index) {
    if (index < 0) index = this.slides.length - 1;
    if (index >= this.slides.length) index = 0;
    this.index = index;
    const target = this.slides[index];
    const offset = target.offsetLeft;
    this.track.style.transform = `translateX(-${offset}px)`;
    this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
  }

  startAutoplay() {
    const speed = Number(this.dataset.autoplaySpeed) || 5000;
    this.timer = setInterval(() => this.go(this.index + 1), speed);
  }

  stopAutoplay() {
    clearInterval(this.timer);
  }
}

customElements.define('hero-slider', HeroSlider);
